"use strict";

exports.__esModule = true;
var _ClassificationButton = require("./ClassificationButton");
Object.keys(_ClassificationButton).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ClassificationButton[key]) return;
  exports[key] = _ClassificationButton[key];
});
var _ClassificationButtonGroup = require("./ClassificationButtonGroup");
Object.keys(_ClassificationButtonGroup).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ClassificationButtonGroup[key]) return;
  exports[key] = _ClassificationButtonGroup[key];
});
var _ClassificationButtonPanel = require("./ClassificationButtonPanel");
Object.keys(_ClassificationButtonPanel).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ClassificationButtonPanel[key]) return;
  exports[key] = _ClassificationButtonPanel[key];
});